<div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-24 card">
  <div class="flex-vertical gap-8">
    <h6>Motivation de l'opération</h6>
  </div>
  <div class="oui-form-line">
    <oui-select
      class="oui-form-field-lg"
      label="Motivation de l'opération"
      [control]="control"
      [options]="options"
      [errors]="errors"></oui-select>
  </div>
</div>
